// Konstanten rund um strategische Empfehlungspartner.

export const PARTNER_TYP_OPTIONS = [
  { value: 'externer_vertriebspartner', label: 'Externer Vertriebspartner' },
  { value: 'kooperationspartner', label: 'Kooperationspartner' },
  { value: 'softwareanbieter', label: 'Softwareanbieter' },
  { value: 'sonstiges', label: 'Sonstiges' },
];

export const PARTNER_TYP_LABEL = Object.fromEntries(
  PARTNER_TYP_OPTIONS.map((o) => [o.value, o.label])
);

// Vier deutlich unterscheidbare Farben — Lila als Brand-Akzent für die
// "Vertriebspartner"-Hauptkategorie.
export const PARTNER_TYP_BADGE = {
  externer_vertriebspartner: 'bg-primary-100 text-primary-800 ring-primary-200',
  kooperationspartner: 'bg-emerald-100 text-emerald-800 ring-emerald-200',
  softwareanbieter: 'bg-orange-100 text-orange-800 ring-orange-200',
  sonstiges: 'bg-slate-100 text-slate-700 ring-slate-200',
};
